<template>
  <v-card>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Zoeken"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      v-if="$vuetify.breakpoint.xs"
      :headers="headers"
      :items="flights | onlyFlyingandLanded"
      :search="search"
      hide-actions
      default-sort="StartTime:desc"
      must-sort
      no-data-text="Geen vluchten vandaag"
      no-results-text="Geen vlucht gevonden"
    >
      <template slot="headers">
        <th class="text-xs-left">
          <div>Gezagvoerder</div>
          <div>Tweede inzittende</div>
        </th>
        <th class="text-xs-left">
          <div>Toestel</div>
        </th>

        <th class="text-xs-left">
          <div>Starttijd</div>
          <div>Vluchtduur</div>
        </th>
      </template>

      <template v-slot:items="props">
        <td class="text-xs-left">
          {{ props.item[1].commander.name }}
          <div
            class="text-xs-left"
            v-if="props.item[1].passenger !== undefined"
          >
            {{ props.item[1].passenger.name }}
          </div>
          <div class="text-xs-left" v-else></div>
        </td>

        <td
          class="text-xs-left"
          v-if="props.item[1].plane.callsign === undefined"
        >
          {{ planeToString(props.item[1].plane) }}
        </td>
        <td class="text-xs-left" v-else>
          {{ props.item[1].plane.callsign }} <br />
          {{ props.item[1].plane.registration }}
        </td>
        <td class="text-xs-left">
          <div v-if="props.item[1].startTime !== undefined">
            {{ props.item[1].startTime | formatedTime }}
          </div>
          <div class="text-xs-left" v-else></div>

          <div
            v-if="props.item[1].endTime === undefined"
            class="text-xs-left red--text font-weight-bold"
          >
            {{ duration(props.item[1]) | formatedDuration }}
          </div>
          <div v-else class="text-xs-left">
            {{ duration(props.item[1]) | formatedDuration }}
          </div>
        </td>
      </template>
    </v-data-table>

    <v-data-table
      v-else
      :headers="headers"
      :items="flights | onlyFlyingandLanded"
      :search="search"
      hide-actions
      default-sort="StartTime:desc"
      must-sort
      no-data-text="Geen vluchten vandaag"
      no-results-text="Geen vlucht gevonden"
    >
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item[1].commander.name }}</td>

        <td class="text-xs-left" v-if="props.item[1].passenger !== undefined">
          {{ props.item[1].passenger.name }}
        </td>
        <td class="text-xs-left" v-else></td>

        <td class="text-xs-left">{{ planeToString(props.item[1].plane) }}</td>
        <td class="text-xs-left" v-if="props.item[1].startTime !== undefined">
          {{ props.item[1].startTime | formatedTime }}
        </td>
        <td class="text-xs-left" v-else></td>

        <td
          v-if="props.item[1].endTime === undefined"
          class="text-xs-left red--text font-weight-bold"
        >
          {{ duration(props.item[1]) | formatedDuration }}
        </td>
        <td v-else class="text-xs-left">
          {{ duration(props.item[1]) | formatedDuration }}
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { db } from "../main";
import moment from "moment";

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Gezagvoerder",
          align: "left",
          sortable: false,
          value: "1.commander.name"
        },
        {
          text: "Tweede inzittende",
          align: "left",
          sortable: false,
          value: "1.passenger.name"
        },
        {
          text: "Toestel",
          align: "left",
          sortable: false,
          value: "1.plane.planeString"
        },
        {
          text: "Starttijd",
          align: "left",
          sortable: true,
          value: "1.startTime"
        },
        {
          text: "Vluchtduur",
          align: "left",
          sortable: true,
          value: "1.duration"
        }
      ],
      flights: [],
      interval: null,
      today: null,
      now: null
    };
  },
  filters: {
    formatedTime(value) {
      if (value) {
        return moment(value).format("HH:mm");
      }
    },
    formatedDuration(value) {
      if (value) {
        var duration = moment.duration(value);
        return (
          Math.floor(duration.asMinutes()) +
          ":" +
          moment.utc(duration.asMilliseconds()).format("ss")
        );
      }
    },
    onlyFlyingandLanded(value) {
      if (value) {
        return value.filter(flight => flight[1].startTime != undefined);
      }
    }
  },
  methods: {
    duration: function(start) {
      var duration = 0;
      if (start.startTime !== undefined && start.endTime !== undefined) {
        duration = start.endTime - start.startTime;
      } else if (start.startTime !== undefined && start.endTime === undefined) {
        duration = this.now - start.startTime;
      }
      start.duration = duration;
      return duration;
    },
    planeToString: function(plane) {
      var planeString = "";
      if (plane.registration !== undefined && plane.callsign !== undefined) {
        planeString = plane.callsign + " (" + plane.registration + ")";
      } else if (
        plane.registration !== undefined &&
        plane.callsign === undefined
      ) {
        planeString = plane.registration;
      }
      plane.planeString = planeString;
      return planeString;
    }
  },
  computed: {
    computedHeaders: function() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return this.$data.headersSmall;
      } else {
        return this.$data.headers;
      }
    }
  },
  created: function() {
    this.$data.now = new moment();
    setInterval(() => {
      this.$data.now = new moment();
    }, 1000);

    var today = new moment();
    this.$data.today = today.format("YYYY-MM-DD");
    var flightsref = db.ref("flydays/" + this.$data.today + "/flights");
    flightsref.on("value", snapshot => {
      this.$data.flights = Object.entries(snapshot.val());
    });
  }
};
</script>
